import { FC } from 'react';

import { IconPreloaded } from './Icon';
import { SvgIcon } from './SvgIcon.type';
import { SvgPreloadedIcon } from './SvgPreloadedIcon';

export const IconMenuPreloaded = () => (
  <SvgPreloadedIcon name="menu" viewBox="0 0 24 24">
    <path d="M4.4 7.4h15.2v1.2H4.4V7.4Zm0 4h15.2v1.2H4.4v-1.2Zm15.2 4H4.4v1.2h15.2v-1.2Z" />
  </SvgPreloadedIcon>
);

export const IconMenu: FC<SvgIcon> = (props) => <IconPreloaded {...props} viewBox="0 0 24 24" name="menu" />;
